<template>
  <div v-if="!response">
    <div class="table-responsive-mobile">
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">{{ $t("message.find_person.search_name") }}</th>
          <th scope="col">{{ $t("message.find_person.search_id_number") }}</th>
          <th scope="col">{{ $t("message.find_person.search_type") }}</th>
          <th scope="col">{{ $t("message.find_person.results_count") }}</th>
          <th scope="col">{{ $t("message.find_person.results_score") }}</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(hist, index) in histories">
          <th class="small" scope="row">{{ index + 1 }}</th>
          <td class="small">{{ hist.name }}</td>
          <td class="small">{{ hist.idcard }}</td>
          <td class="small">{{ $t("message.find_person.types." + (hist.dataType || "all")) }}</td>
          <th class="small">{{ resultsCount(hist.response) }}</th>
          <th class="small">{{ hist.response.resultsScore || "-" }}</th>
          <td>
            <button class="btn btn-primary btn-sm p-0 h-auto" @click="() => handleToggleHistory(hist.response)">
              <span class="m-0 px-3 py-2">{{ $t("message.find_person.view") }}</span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
  <div v-else-if="response">
    <ListView :isHistory="true" :data="response" @handle-back="handleToggleHistory()" />
  </div>
</template>
<script>
import ListView from "./components/list-view.vue";
export default {
  components: { ListView },
  data() {
    return {
      response: null,
      histories: [
        // {
        //   "name": "",
        //   "idcard": "",
        //   "dataType": "",
        //   "pageno": "1",
        //   "locale": "ru",
        //   "dataId": null,
        //   "response": {},
        // }
      ],
    };
  },
  async mounted() {
    try {
      const res = await axios.get(window.base + "/PersonalLegalInfo/GetSearchHistory?searchType=1");
      const reversed = res.data.reverse();
      this.histories = reversed.map((item) => {
        const parsedResponse = JSON.parse(item.response);
        return {
          ...item,
          response: {
            ...parsedResponse.resp_data,
            resultsScore: parsedResponse?.police_info?.data?.score || null,
            resp_code: parsedResponse.resp_code,
            searchInputName: item.name,
          },
        }
      });
    } catch (e) {
      console.error("GetSearchHistory", e);
    }
  },
  methods: {
    handleToggleHistory(response = null) {
      this.response = response;
    },
    resultsCount(response) {
      const cc = (x) => (Array.isArray(x) && x.length) || 0;
      return cc(response.allList) +
        cc(response.cpwsList) +
        cc(response.ktggList) +
        cc(response.zxggList) +
        cc(response.shixinList) +
        cc(response.fyggList) +
        cc(response.ajlcList) +
        cc(response.bgtList) +
        cc(response.sifacdkList) +
        cc(response.pmggList);
    },
  },
  computed: {},
  watch: {},
};
</script>
<style scoped>
@media (max-width: 768px) {
  .table-responsive-mobile {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-mobile table {
    min-width: 600px;
  }
}</style>